import React from 'react';
import PropTypes from 'prop-types';
import Typography from '@material-ui/core/Typography';

// COMPONENTS
import RouterLink from '@/components/Link';

// STYLES
import { SectionTitleWrapper } from './styles';

function SectionTitleLink({
  className,
  title,
  link,
  analyticsLocation,
  LinkProps,
  TypoProps,
  bottomContent,
}) {
  let typoProps = { ...TypoProps };

  if (link) {
    typoProps = { ...typoProps, ...LinkProps };
  }

  return (
    <SectionTitleWrapper className={className}>
      <Typography
        variant="h4"
        align="left"
        className="title"
        component={link ? RouterLink : 'h4'}
        to={link}
        location={analyticsLocation}
        {...typoProps}
      >
        {title}
        {!!link && <i className="icon-chevron-right" />}
      </Typography>
      {bottomContent}
    </SectionTitleWrapper>
  );
}

SectionTitleLink.defaultProps = {
  className: '',
  analyticsLocation: '',
  LinkProps: {},
  TypoProps: {},
};

SectionTitleLink.propTypes = {
  className: PropTypes.string,
  title: PropTypes.string.isRequired,
  link: PropTypes.oneOfType([PropTypes.string, PropTypes.oneOf([null])]),
  analyticsLocation: PropTypes.string,
  LinkProps: PropTypes.object,
  TypoProps: PropTypes.object,
  bottomContent: PropTypes.oneOfType([
    PropTypes.element,
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node,
  ]),
};

export default React.memo(SectionTitleLink);
